var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Deliverypros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 57 23"
    },
    viewBox: "0 0 57 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#4c4c4c}.st1{fill:#fff}.st2{fill:#4c4c4c;stroke:#fafafa;stroke-width:.75}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_0_x5F_May"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_driver2truck-copy",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.5 10c.4 0 .8.1 1.2.2l-.1.1c-.3.4-.6.7-.8 1.1h-.3c-1.2 0-2.1 1-2.1 2.1s.9 2 2 2.1l-.1 1.2v.2C4.5 16.9 3 15.4 3 13.5c0-2 1.6-3.5 3.5-3.5zM21.3 0c.2 0 .5.1.7.2.5.3.8.8.9 1.4.1.6.2 1.3.2 1.9h-.6c-.5.1-1.1.4-1.5.9V2.3c0-.3-.1-.5-.2-.7-.1-.1-.3-.2-.5-.3h-3.4v3.3h3.8c-.1.2-.3.3-.3.4l-.5.7-.4.6-.4.7-.2.3-.2.3c-.2.2-.5.4-.7.5-.2.1-.4.2-.5.2H17l-1 .1-1 .1-1 .1c-1 .1-2 .1-2.8.1-1 0-1.9.3-2.6.8l-1.2-.3c-1.5-.2-3 .3-4 1.3-.3.3-.6.8-.6 1.2-.1.7-.2 1.4-.1 2.1 0 1.2-2.6.6-2.7-1.1v-.2L.2 8s1.2-2.7 3.9-2.7c2.2 0 5.3-.3 6.4-.4.3 0 .6-.1.9-.3.3-.2.6-.4.8-.7.5-.6 1.3-1.9 1.6-2.3l.1-.1S14.8 0 15.6 0h5.7zm9.3 5.5h10.5s.9.3 1 1.6c0 .4.1 1.1.1 1.9H30.9v-.1c0-1 0-2.1-.2-3.1-.1-.1-.1-.2-.1-.3zM16.4 1.3h-.6c-2.3 2.8-.6 3.2-.6 3.3h1.2V1.3z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.099 11.2c-.1-1.3-1-1.6-1-1.6h-17.2c-.7 0-.8-.9-.8-.9 0-1 0-2-.2-3-.1-.6-.5-1-.9-1.4-.2-.1-.5-.2-.7-.2h-5.7c-.9 0-1.7 1.3-1.7 1.3s-1.2 1.7-1.7 2.4c-.2.3-.5.5-.8.7-.3.2-.6.3-.9.3-1.1.2-4.2.5-6.4.5-2.7 0-3.9 2.8-3.9 2.8l-.2 4.6c-.1 1.8 2.7 2.5 2.6 1.3 0-.7 0-1.4.1-2.1.1-.5.3-.9.6-1.2 1.1-1 2.6-1.5 4-1.3 3.2.3 3.2 4.7 3.2 4.7h17.3c0-1.6.8-4.8 4.6-4.8s3.7 3.9 3.7 3.9 1.2.4 3.7-.1c2.8-.7 2.5-4.6 2.3-5.9zm-25.7-2.5h-1.2s-1.8-.4.6-3.3h.6v3.3zm4.6 0s-4.1-.1-4.2 0V5.4h3.2c.3 0 .5.1.7.3.3.2.4.4.3.7v2.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.399 14.1c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.5-3.5-3.5-3.5zm0 5.6c-.9 0-1.6-.5-2-1.3a2.176 2.176 0 0 1 2.8-2.8c.8.3 1.3 1.1 1.3 2 0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.5.6zm-25.9-5.6c-1.9 0-3.5 1.5-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.5-3.5-3.5-3.5zm0 5.6c-1.2 0-2.1-1-2.1-2.1 0-1.2 1-2.1 2.1-2.1s2.1 1 2.1 2.1c0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.5.6z",
    className: "st0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.2 3H2.8C1.3 3 0 4.2 0 5.7V12c0 .9.7 1.6 1.6 1.6h.1c.1 0 .2 0 .3-.1V20c0 1 .8 1.8 1.8 1.8h.1c.4 0 .7-.2 1-.4l.1-.1.1.1c.3.3.7.4 1.1.4 1 0 1.8-.8 1.8-1.8v-6.5h.4c.9 0 1.6-.7 1.6-1.6V5.7C10 4.2 8.7 3 7.2 3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    d: "M7.2 3.8c1 0 1.9.8 2 1.8V12c0 .4-.3.8-.7.8h-.2c-.4 0-.7-.4-.7-.7V5.7c0-.1-.1-.1-.2-.1s-.2.1-.2.2V20c0 .6-.4 1-1 1-.5 0-.9-.4-1-.9v-8.2h-.4V20c0 .6-.4 1-1 1-.5 0-.9-.4-1-.9V5.8c0-.1-.1-.2-.2-.2s-.1 0-.2.1V12c0 .4-.3.8-.7.8h-.1c-.4 0-.8-.3-.8-.7V5.8c0-1 .8-1.9 1.8-2h4.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 1.7,
    r: 2.1,
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(46.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    d: "M7.2 3H2.8C1.3 3 0 4.2 0 5.7V12c0 .9.7 1.6 1.6 1.6h.1c.1 0 .2 0 .3-.1V20c0 1 .8 1.8 1.8 1.8h.1c.4 0 .7-.2 1-.4l.1-.1.1.1c.3.3.7.4 1.1.4 1 0 1.8-.8 1.8-1.8v-6.5h.4c.9 0 1.6-.7 1.6-1.6V5.7C10 4.2 8.7 3 7.2 3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M7.2 3.8c1 0 1.9.8 2 1.8V12c0 .4-.3.8-.7.8h-.2c-.4 0-.7-.4-.7-.7V5.7c0-.1-.1-.1-.2-.1s-.2.1-.2.2V20c0 .6-.4 1-1 1-.5 0-.9-.4-1-.9v-8.2h-.4V20c0 .6-.4 1-1 1-.5 0-.9-.4-1-.9V5.8c0-.1-.1-.2-.2-.2s-.1 0-.2.1V12c0 .4-.3.8-.7.8h-.1c-.4 0-.8-.3-.8-.7V5.8c0-1 .8-1.9 1.8-2h4.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    cx: 5,
    cy: 1.7,
    r: 2.1,
    className: "st2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Deliverypros);
export default __webpack_public_path__ + "static/media/2deliverypros.d9e5090b7c1ab7316338d6d37445ee7a.svg";
export { ForwardRef as ReactComponent };